<div
  style="height: 400px"
  class="pie-container"
  echarts
  [options]="piechartOption"
  [autoResize]="true"
></div>
